export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/guitar.df520bd.svg";